/**
 * Header con selector de sucursal activa
 * Completamente responsive con botón de menú en móvil
 */
import React from "react";
import { Layout, Select, Space, Typography, Tag, Button } from "antd";
import { ShopOutlined, ExperimentOutlined, MenuOutlined } from "@ant-design/icons";
import { useBranch } from "../../context/BranchContext";

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = ({ onMenuClick, showMenuButton = false }) => {
  const { activeBranch, setActiveBranch, branches, loading } = useBranch();

  const handleBranchChange = (branchId) => {
    setActiveBranch(branchId);
  };

  const selectedBranch = branches.find((b) => b.value === activeBranch);

  return (
    <AntHeader
      style={{
        position: "fixed",
        top: 0,
        left: showMenuButton ? 0 : 260,
        right: 0,
        background: "linear-gradient(135deg, #fff 0%, #f8f9fa 100%)",
        padding: showMenuButton ? "0 12px" : "0 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        borderBottom: "1px solid #e8e8e8",
        height: 64,
        zIndex: 99,
      }}
    >
      <Space size="middle" style={{ flex: 1, overflow: "hidden" }}>
        {showMenuButton && (
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: 20 }} />}
            onClick={onMenuClick}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 40,
              height: 40,
            }}
          />
        )}
        {!showMenuButton && (
          <ShopOutlined style={{ fontSize: 20, color: "#667eea" }} />
        )}
        <Text strong style={{ fontSize: showMenuButton ? 13 : 14, whiteSpace: "nowrap", fontWeight: 600 }}>
          Sucursal:
        </Text>
        <Select
          value={activeBranch}
          onChange={handleBranchChange}
          loading={loading}
          style={{
            width: showMenuButton ? 180 : 320,
            borderRadius: 8,
            minWidth: showMenuButton ? 120 : 200,
          }}
          placeholder="Seleccionar"
        >
          {branches.map((branch) => (
            <Select.Option key={branch.value} value={branch.value}>
              {branch.label}
            </Select.Option>
          ))}
        </Select>
        {selectedBranch && !showMenuButton && (
          <Tag
            color="blue"
            style={{
              borderRadius: 6,
              padding: "4px 12px",
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            {selectedBranch.label}
          </Tag>
        )}
      </Space>
      <Space size="middle" style={{ flexShrink: 0 }}>
        <Tag
          color="success"
          style={{
            borderRadius: 6,
            padding: showMenuButton ? "2px 8px" : "4px 12px",
            fontSize: showMenuButton ? 11 : 12,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <ExperimentOutlined />
          {showMenuButton ? "Demo" : "Modo Demo"}
        </Tag>
        {!showMenuButton && (
          <Text type="secondary" style={{ fontSize: 12, fontWeight: 400 }}>
            Datos en localStorage
          </Text>
        )}
      </Space>
    </AntHeader>
  );
};

export default Header;

